/* Lexique des huiles — recherche, index A-Z, filtre par besoin.
   Les fiches sont deja dans le HTML : ce script ne fait que les masquer.
   Il recolle aussi les pages suivantes de la pagination pour que les filtres
   portent sur tout le repertoire. Le compteur du haut n'est jamais modifie,
   pour eviter que le chiffre saute sous les yeux au chargement. */
(function () {
  var root = document.querySelector('[data-lexhe]');
  if (!root) return;

  var grid = root.querySelector('[data-lex-grid]');
  var search = root.querySelector('[data-lex-search]');
  var result = root.querySelector('[data-lex-result]');
  var none = root.querySelector('[data-lex-none]');
  var besoinsWrap = root.querySelector('[data-lex-besoins]');
  var pager = root.querySelector('[data-lex-pager]');
  var letters = Array.prototype.slice.call(root.querySelectorAll('[data-lex-letter]'));
  var state = { q: '', letter: '', besoin: '' };
  var cards = [];
  var touche = false;

  function norm(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }

  function prep() {
    cards = Array.prototype.slice.call(grid.querySelectorAll('.lexique__card'));
    cards.forEach(function (c) {
      if (c._prepare) return;
      c._s = norm(c.getAttribute('data-s'));
      c._l = norm(c.getAttribute('data-l')).charAt(0);
      var b = c.getAttribute('data-b') || '';
      c._b = b ? b.split('|') : [];
      c._prepare = true;
    });
  }

  function mkBesoin(label, value) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lexique__letter' + (state.besoin === value ? ' is-active' : '');
    b.textContent = label;
    b.addEventListener('click', function () {
      state.besoin = (state.besoin === value ? '' : value);
      Array.prototype.slice.call(besoinsWrap.children).forEach(function (c) { c.classList.remove('is-active'); });
      if (state.besoin !== '') { b.classList.add('is-active'); }
      else { besoinsWrap.firstChild.classList.add('is-active'); }
      touche = true;
      render();
    });
    return b;
  }

  function buildBesoins() {
    if (!besoinsWrap) return;
    var seen = {};
    cards.forEach(function (c) { c._b.forEach(function (b) { seen[b] = 1; }); });
    var liste = Object.keys(seen).sort(function (a, b) { return a.localeCompare(b, 'fr'); });
    besoinsWrap.innerHTML = '';
    besoinsWrap.appendChild(mkBesoin('Tous', ''));
    liste.forEach(function (b) { besoinsWrap.appendChild(mkBesoin(b, b)); });
  }

  function render() {
    var n = 0;
    cards.forEach(function (c) {
      var ok = true;
      if (state.letter && c._l !== state.letter) ok = false;
      if (ok && state.besoin && c._b.indexOf(state.besoin) === -1) ok = false;
      if (ok && state.q && c._s.indexOf(state.q) === -1) ok = false;
      c.hidden = !ok;
      if (ok) n++;
    });
    if (result) result.textContent = touche ? (n + (n === 1 ? ' huile' : ' huiles')) : '';
    if (none) none.hidden = n !== 0;
  }

  function pageUrl(p) {
    var sp = new URLSearchParams(window.location.search);
    sp.set('page', p);
    return window.location.pathname + '?' + sp.toString();
  }

  prep();
  buildBesoins();
  render();

  if (search) {
    search.addEventListener('input', function () {
      state.q = norm(search.value.trim());
      touche = true;
      render();
    });
  }

  letters.forEach(function (btn) {
    btn.addEventListener('click', function () {
      letters.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      state.letter = norm(btn.getAttribute('data-lex-letter'));
      touche = true;
      render();
    });
  });

  var pages = window.__lexPages || 1;
  if (pages > 1 && window.fetch && window.URLSearchParams) {
    var jobs = [];
    for (var p = 2; p <= pages; p++) {
      jobs.push(fetch(pageUrl(p), { credentials: 'same-origin' }).then(function (r) { return r.text(); }));
    }
    Promise.all(jobs).then(function (htmls) {
      var frag = document.createDocumentFragment();
      var ajout = 0;
      htmls.forEach(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var extra = doc.querySelectorAll('.lexique__card');
        for (var i = 0; i < extra.length; i++) {
          frag.appendChild(document.importNode(extra[i], true));
          ajout++;
        }
      });
      if (ajout > 0) {
        grid.appendChild(frag);
        prep();
        buildBesoins();
        render();
        if (pager) pager.remove();
      }
    }).catch(function () { /* on garde la pagination */ });
  }
})();
